var ParentResolver_1;
import * as tslib_1 from "tslib";
import { containerResolver } from '../protocol/resolver';
/**
 * Used to inject the dependency from the parent container instead of the current one.
 */
let ParentResolver = ParentResolver_1 = class ParentResolver {
    /**
     * Creates an instance of the Parent class.
     * @param key The key to resolve from the parent container.
     */
    constructor(key) {
        this._key = key;
    }
    /**
     * Creates a Parent Resolver for the supplied key.
     * @param key The key to resolve.
     * @return Returns an instance of Parent for the key.
     */
    static of(key) {
        return new ParentResolver_1(key);
    }
    /**
     * Called by the container to load the dependency from the parent container
     * @param container The container to resolve the parent from.
     * @return Returns the matching instance from the parent container
     */
    get(container) {
        return container.parent ? container.parent.get(this._key) : null;
    }
};
ParentResolver = ParentResolver_1 = tslib_1.__decorate([
    containerResolver,
    tslib_1.__metadata("design:paramtypes", [Object])
], ParentResolver);
export { ParentResolver };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFyZW50UmVzb2x2ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJQYXJlbnRSZXNvbHZlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQU9BLE9BQU8sRUFBRSxpQkFBaUIsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBR3pEOztHQUVHO0FBRUgsSUFBYSxjQUFjLHNCQUEzQixNQUFhLGNBQWM7SUFhdkI7OztPQUdHO0lBQ0gsWUFBbUIsR0FBVztRQUMxQixJQUFJLENBQUMsSUFBSSxHQUFHLEdBQUcsQ0FBQztJQUNwQixDQUFDO0lBbEJEOzs7O09BSUc7SUFDSSxNQUFNLENBQUMsRUFBRSxDQUFJLEdBQVc7UUFDM0IsT0FBTyxJQUFJLGdCQUFjLENBQUksR0FBRyxDQUFDLENBQUM7SUFDdEMsQ0FBQztJQWFEOzs7O09BSUc7SUFDSSxHQUFHLENBQUMsU0FBb0I7UUFDM0IsT0FBTyxTQUFTLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztJQUNyRSxDQUFDO0NBQ0osQ0FBQTtBQTdCWSxjQUFjO0lBRDFCLGlCQUFpQjs7R0FDTCxjQUFjLENBNkIxQjtTQTdCWSxjQUFjIn0=